import { useEffect } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { updateDateFilter, updateFiltersStates } from '../store/actions/UserActions';
import { getCurrentFinancialYear } from '../utility/CommonFunctions';

const useResetOnReload = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const wasReloaded = localStorage.getItem('wasPageReloaded') === 'true';

        if (wasReloaded) {
            localStorage.removeItem('wasPageReloaded');
            dispatch(updateFiltersStates({
                currentPage: 1,
                pageSize: 10,
                count: 0,
                totalPages: 0,
                sortByDate: [
                    moment(moment().subtract(30, "days").toDate()).format(
                        "YYYY-MM-DD"
                    ),
                    moment(moment().toDate()).format("YYYY-MM-DD"),
                ],
                year: getCurrentFinancialYear(),
                companyId: "",
                // siteId: "",
                department: "",
                designation: "",
                requestType: "",
                stockStatus: "",
                paymentStatus: "",
                vendorId: "",
                empStatus: "current",
                customerId: "",
                customerCompanyId: "",
                due: "",
            }));
            dispatch(updateDateFilter(
                [
                    moment().startOf("month").format("YYYY-MM-DD"),
                    moment().endOf("month").format("YYYY-MM-DD"),
                ]
            ))
        }
        const handleBeforeUnload = () => {
            localStorage.setItem('wasPageReloaded', 'true');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [dispatch]);
};

export default useResetOnReload;
